import _ from "lodash";
import siteConfig from "site-config";
import { UNLINKED_MEDIA } from "constants/action-types";
import querystring from "querystring";
import { IMediaAssetMap, IUpdateMediaAssetOperation } from "constants/media-asset";
import { MEDIA_TYPE_IMAGE, MEDIA_TYPE_THREEDIUM, MEDIA_TYPE_VIDEO } from "constants/media";
import { IUnlinkedMediaResource } from "../constants/unlinked-media";

export interface IFetchUnlinkedMediaParams {
    search?: string;
    lastFilename?: string;
    limit?: number;
    includeLinked?: boolean;
}

export const UNLINKED_MEDIA_PAGE_SIZE = 50;

export const fetchUnlinkedMedia = (merchant_id: string, params: IFetchUnlinkedMediaParams = {}) => {
    const { search = "", limit = UNLINKED_MEDIA_PAGE_SIZE, lastFilename = "", includeLinked = false } = params;
    const query = querystring.stringify({
        query: search,
        from_filename: lastFilename,
        limit,
        allow_linked: includeLinked,
    });
    return {
        type: UNLINKED_MEDIA.FETCH.START,
        payload: { url: `${siteConfig.goAPI}/v1/ingestionimage/${merchant_id}/search?${query}` },
    };
};

export const linkMediaToProduct = (
    productId: string,
    revision: string,
    mediaMap: IMediaAssetMap,
    operations: IUpdateMediaAssetOperation[]
) => {
    const unlinkedMedia = _.pickBy(mediaMap, ({ unlinkedMedia }) => unlinkedMedia);
    const mediaResources = _.map(unlinkedMedia, ({ type, image_id, media_id, upload_id }) => {
        const resources = {
            [MEDIA_TYPE_IMAGE]: { image: { image_id } },
            [MEDIA_TYPE_VIDEO]: { video: { media_id } },
            [MEDIA_TYPE_THREEDIUM]: { threedium: { upload_id } },
        };
        return { kind: type, media_resource: resources[type] } as IUnlinkedMediaResource;
    });
    return {
        type: UNLINKED_MEDIA.LINK.START,
        payload: { productId, revision, mediaMap, mediaResources, operations },
    };
};

export const markMediaAsLinked = (merchant_id: string, mediaMap: IMediaAssetMap) => {
    const unlinkedMedia = _.pickBy(mediaMap, ({ unlinkedMedia }) => unlinkedMedia);
    const updates = _.map(unlinkedMedia, (media) => ({
        id: media.id,
        image: { linked: true },
        field_mask: { paths: ["linked"] },
    }));
    return {
        type: UNLINKED_MEDIA.UPDATE_LINKS_STATE.START,
        payload: { merchant_id, updates },
    };
};

export const reset = () => ({ type: UNLINKED_MEDIA.RESET });
